import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog } from 'element-react'

const FeatureFlagDialog = props => {
    const { cancel, feature, featureFlagging, show } = props

    return (
        show && (
            <Dialog
                className="request-type-dialog"
                size="large"
                title=" "
                visible={true}
                onCancel={cancel}
            >
                <Dialog.Body>
                    <div className="row max400">
                        <h4>Change Feature Flag?</h4>
                        <p>
                            Are you sure you want to turn{' '}
                            {feature.active ? 'OFF' : 'ON'} the {feature.name}{' '}
                            feature?
                        </p>
                        <br />
                        <div style={{ textAlign: 'right' }}>
                            <Button onClick={cancel}>No</Button>
                            <Button type="primary" onClick={featureFlagging}>
                                Yes
                            </Button>
                        </div>
                    </div>
                </Dialog.Body>
            </Dialog>
        )
    )
}

FeatureFlagDialog.propTypes = {
    cancel: PropTypes.func.isRequired,
    featureFlagging: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    feature: PropTypes.object,
}

export default FeatureFlagDialog
